import consumer from "./consumer"
import t from "../i18n"

let notificationSubscription

function subscribeToNotifications() {
    if (notificationSubscription || !document.getElementById("notifications-list")) {
        return
    }

    notificationSubscription = consumer.subscriptions.create("NotificationsChannel", {

        connected() {
            console.log("WebSocket connected to NotificationsChannel");
        },

        disconnected() {
            console.log("WebSocket disconnected from NotificationsChannel");
        },

        received(data) {
            console.log("Data received from ActionCable: ", data);
            if (data.job_statuses_html) {
                updateSidebarJobStatuses(data.job_statuses_html);
            }

            if (!data.notification_html) {
                return;
            }

            // Update the notifications list
            const notificationsList = document.getElementById("notifications-list")
            if (!notificationsList) return;
            notificationsList.insertAdjacentHTML("afterbegin", data.notification_html)

            // Update every rendered unread count badge, including mobile navigation.
            const badges = document.querySelectorAll("[data-notification-badge], #notification-badge")
            badges.forEach((badge) => {
                badge.textContent = data.unread_count

                if (data.unread_count > 0) {
                    badge.style.display = ''
                } else {
                    badge.textContent = t("common.no_notifications", {}, "Keine Benachrichtigungen")
                    badge.style.display = 'none'
                }
            })
        }
    });
}

function updateSidebarJobStatuses(html) {
    const currentPanel = document.getElementById("sidebar-job-statuses");
    if (!currentPanel) return;

    currentPanel.outerHTML = html;
    scheduleFinishedJobStatusRemoval();
}

function scheduleFinishedJobStatusRemoval() {
    const finishedCards = document.querySelectorAll("[data-job-status-state='done'], [data-job-status-state='failed']");

    finishedCards.forEach((card) => {
        if (card.dataset.removalScheduled === "true") return;
        card.dataset.removalScheduled = "true";

        window.setTimeout(() => {
            card.classList.add("is-leaving");
            window.setTimeout(() => {
                const panel = document.getElementById("sidebar-job-statuses");
                card.remove();
                if (panel && !panel.querySelector("[data-job-status-id]")) {
                    panel.classList.add("is-empty");
                }
            }, 420);
        }, 2800);
    });
}

document.addEventListener("DOMContentLoaded", subscribeToNotifications)
document.addEventListener("turbolinks:load", subscribeToNotifications)
document.addEventListener("DOMContentLoaded", scheduleFinishedJobStatusRemoval)
document.addEventListener("turbolinks:load", scheduleFinishedJobStatusRemoval)
